<div
  class="container"
  *ngIf="searchTerm"
>
  <div
    class="categories-container"
    *ngIf="hasFoundCategories"
  >
    <span class="header-copy">Categories</span>
    <div
      class="category-container"
      *ngFor="let category of foundCategoryMap | keyvalue"
    >
      <div class="category-name-container">
        <span class="category-name">{{ category.key }}</span>
      </div>
      <div
        class="subcategories-container"
        *ngFor="let subcategory of category.value"
      >
        <button
          class="blank-button subcategory"
          merriNoFocusLink
          (click)="onSubcategoryClick(category.key, subcategory)"
        >
          <span class="subcategory-name">{{ subcategory }}</span>
          <mat-icon svgIcon="chevron_right"></mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="search-results-container">
    <span
      class="header-copy"
      *ngIf="!loading"
      >Items ({{ foundItemsCount }})</span
    >
    <app-visionboard-item-search-results
      class="results"
      [source]="source"
      (itemClicked)="onItemClicked($event)"
      [disableDrag]="true"
      [itemCustomAddRemoveTemplate]="itemCustomAddRemoveTemplate"
      [forceVisionboardItemAddRemoveButton]="forceVisionboardItemAddRemoveButton"
    ></app-visionboard-item-search-results>
  </div>
</div>
